import { Component, Input } from '@angular/core';
import { Kontaktperson } from '../../../../../model/kontaktperson';
import { FocusableIfVisibleDirective } from '../../../../../shared/directives/focusable-if-visible.directive';
import { KontaktAvatarComponent } from './kontakt-avatar/kontakt-avatar.component';

@Component({
  selector: 'now-wbsuche-lib-kontakt-slider-kachel',
  templateUrl: './kontakt-slider-kachel.component.html',
  styleUrls: ['./kontakt-slider-kachel.component.scss'],
  imports: [KontaktAvatarComponent, FocusableIfVisibleDirective]
})
export class KontaktSliderKachelComponent {
  @Input({ required: true }) person!: Kontaktperson;

  @Input()
  public collapsed?: boolean;
}
